import { type UniquePageProps } from "../index";
import { HowCreateConsolidatedOrderModel } from "@admin/domain/uniquePages/models/HowCreateConsolidatedOrderModel";
import HowCreateConsolidatedOrderActionBlocks from "./HowCreateConsolidatedOrderActionBlocks";
import React from "react";

export default function HowCreateConsolidatedOrderPage({ page }: UniquePageProps<HowCreateConsolidatedOrderModel>) {
    return (
        <div>
            <h2 className="mb-5">
                Контент страницы "Как оформить Консолидированный заказ в интернет-магазине Tentorium.ru"
            </h2>
            <HowCreateConsolidatedOrderActionBlocks initActionBLocks={page.contentObject.action_blocks} />
        </div>
    );
}
